/**
* @license Copyright (c) Microsoft Corporation.  All rights reserved.
*/
export class CommonUtils {
    static getTopWindow() {
        try {
            // Testing top window's availability
            // In iframe this will cause an exception as you can't access dispatchEvent
            window.top.dispatchEvent;
            return window.top;
        }
        catch (e) {
            // Assuming iframe scenario
            // Getting top available window
            return this.getTopIframeWindow();
        }
    }
    static getTopIframeWindow() {
        let current = window;
        let parent = current.parent;
        let retry = 10; // Additional safety
        try {
            while (retry && parent && current !== parent) {
                // Testing window's availability
                if (!(parent === null || parent === void 0 ? void 0 : parent.dispatchEvent)) {
                    break;
                }
                current = parent;
                parent = current.parent;
                --retry;
            }
        }
        catch (e) {
            // Silencing
        }
        return current;
    }
}
//# sourceMappingURL=CommonUtils.js.map